/**
 * Card Product Carousel
 * Handles dot navigation and mobile swipe for collection card image carousel
 */

(function () {
  'use strict';

  const ACTIVE_IMG = 'card-product__img--active';
  const HIDDEN_IMG = 'card-product__img--hidden';
  const ACTIVE_DOT = 'card-product__dot--active';

  function initCard(card) {
    const mediaLink = card.querySelector('[data-carousel-media]');
    const dots = card.querySelectorAll('.card-product__dot');

    if (!mediaLink || dots.length < 2) return;

    const images = mediaLink.querySelectorAll('.card-product__img');
    if (images.length < 2) return;

    let currentIndex = 0;

    // ── Dot click ──────────────────────────────────────────────
    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(parseInt(dot.dataset.dotIndex, 10));
      });

      // Desktop: hover over dot swaps image
      dot.addEventListener('mouseenter', () => {
        goTo(parseInt(dot.dataset.dotIndex, 10));
      });
    });

    // ── Mobile swipe ───────────────────────────────────────────
    let touchStartX = 0;
    let touchEndX = 0;
    const SWIPE_THRESHOLD = 40;

    mediaLink.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    mediaLink.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) < SWIPE_THRESHOLD) return;

      if (diff > 0) {
        // Swiped left — next image
        goTo((currentIndex + 1) % images.length);
      } else {
        // Swiped right — previous image
        goTo((currentIndex - 1 + images.length) % images.length);
      }
    }

    // ── Reset on mouse leave ───────────────────────────────────
    card.addEventListener('mouseleave', () => {
      goTo(0);
    });

    // ── Core swap function ─────────────────────────────────────
    function goTo(index) {
      if (index === currentIndex) return;

      images[currentIndex].classList.remove(ACTIVE_IMG);
      images[currentIndex].classList.add(HIDDEN_IMG);
      dots[currentIndex].classList.remove(ACTIVE_DOT);

      images[index].classList.add(ACTIVE_IMG);
      images[index].classList.remove(HIDDEN_IMG);
      dots[index].classList.add(ACTIVE_DOT);

      currentIndex = index;
    }
  }

  // ── Init all cards on page ─────────────────────────────────
  function initAll() {
    document.querySelectorAll('.card-product').forEach(initCard);
  }

  // ── Handle dynamic content (e.g. infinite scroll, filters) ──
  function observeNewCards() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.classList.contains('card-product')) {
            initCard(node);
          } else {
            node.querySelectorAll?.('.card-product').forEach(initCard);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Boot ───────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
      observeNewCards();
    });
  } else {
    initAll();
    observeNewCards();
  }
})();
